var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "stroke",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8877 10.8965C19.2827 10.7005 20.3567 9.50448 20.3597 8.05548C20.3597 6.62748 19.3187 5.44348 17.9537 5.21948",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7285 14.2502C21.0795 14.4522 22.0225 14.9252 22.0225 15.9002C22.0225 16.5712 21.5785 17.0072 20.8605 17.2812",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8867 14.6636C8.67273 14.6636 5.92773 15.1506 5.92773 17.0956C5.92773 19.0396 8.65573 19.5406 11.8867 19.5406C15.1007 19.5406 17.8447 19.0586 17.8447 17.1126C17.8447 15.1666 15.1177 14.6636 11.8867 14.6636Z",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8864 11.8878C13.9954 11.8878 15.7054 10.1788 15.7054 8.06876C15.7054 5.95976 13.9954 4.24976 11.8864 4.24976C9.77744 4.24976 8.06741 5.95976 8.06741 8.06876C8.05944 10.1708 9.75644 11.8808 11.8584 11.8878H11.8864Z",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88411 10.8965C4.48811 10.7005 3.41511 9.50448 3.41211 8.05548C3.41211 6.62748 4.45311 5.44348 5.81811 5.21948",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.044 14.2502C2.693 14.4522 1.75 14.9252 1.75 15.9002C1.75 16.5712 2.194 17.0072 2.912 17.2812",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGroup);
export default __webpack_public_path__ + "static/media/user-group.6f1723639d1ec3dbfb66641676f43e93.svg";
export { ForwardRef as ReactComponent };